import React from 'react';
import { Mail, Phone, MapPin, ArrowUp, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const links = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Solutions', href: '#solutions' },
    { name: 'Industries', href: '#industries' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    'Digital Government',
    'Software Development',
    'Cloud & DevOps',
    'Cybersecurity',
    'ERP Systems',
    'AI & Analytics'
  ];

  return (
    <footer className="relative bg-slate-900 pt-20 pb-8">
      {/* Top Border Gradient */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-cyan-500 to-blue-500" />
      
      {/* Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`,
        backgroundSize: '24px 24px'
      }} />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 via-cyan-500 to-blue-500 flex items-center justify-center shadow-lg shadow-blue-500/30">
                <span className="text-white font-bold text-2xl font-display">A</span>
              </div>
              <div>
                <span className="text-white font-bold text-xl font-display">ANCARTA</span>
                <span className="block text-blue-400 text-[10px] uppercase tracking-[0.15em]">Technologies</span>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Delivering secure, scalable, and future-ready digital solutions for governments and enterprises worldwide.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-blue-500 flex items-center justify-center text-slate-400 hover:text-white transition-all">
                <Linkedin size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-cyan-500 flex items-center justify-center text-slate-400 hover:text-white transition-all">
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-slate-400 hover:text-blue-400 transition-colors text-sm">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-slate-400 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a href="mailto:info@ancarta.co.in" className="flex items-center gap-3 text-slate-400 hover:text-blue-400 transition-colors text-sm">
                  <Mail size={16} className="text-blue-500" />
                  info@ancarta.co.in
                </a>
              </li>
              <li>
                <a href="tel:+918755910457" className="flex items-center gap-3 text-slate-400 hover:text-blue-400 transition-colors text-sm">
                  <Phone size={16} className="text-cyan-500" />
                  +91 8755910457
                </a>
              </li>
              <li>
                <span className="flex items-start gap-3 text-slate-400 text-sm">
                  <MapPin size={16} className="text-blue-500 mt-0.5" />
                  Lucknow, Uttar Pradesh, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} ANCARTA TECHNOLOGIES PRIVATE LIMITED. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <a href="#" className="text-slate-500 hover:text-blue-400 transition-colors">Privacy Policy</a>
            <a href="#" className="text-slate-500 hover:text-blue-400 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>

      {/* Scroll to Top */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 transition-all hover:-translate-y-1 z-50"
      >
        <ArrowUp size={20} />
      </button>
    </footer>
  );
};

export default Footer;
